export const rootStackSx = {
  width: '100%',
  gap: 2,
  p: 3,
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.s,
};

export const headerStackSx = { alignItems: 'center', justifyContent: 'space-between' };
